import { createReducer } from "@reduxjs/toolkit";
import { decrementOpenRequests, incrementOpenRequests, resetAll, } from "../actions";
const syncStateErrorMessage = `
Warning: tried to decrease sync state below 0. Possible causes:
- decrement is called but increment was not
- a new configuration was started, resumed or loaded while the previous one was still fetching
- React StrictMode during development causing useEffect hooks to run twice
`;
/**
 * FIXME There edge cases where it becoming negative during development. This is why we currently do not reset the sync state
 * @private
 */
export const syncStateReducer = createReducer(0, (builder) => builder
    .addCase(incrementOpenRequests, (state) => state + 1)
    .addCase(decrementOpenRequests, (state) => {
    const nextState = state - 1;
    // edge cases occurs if sync state is reset
    if (nextState < 0) {
        console.log(`%c${syncStateErrorMessage}`, "color: orange;");
    }
    return Math.max(0, nextState);
})
    // do not reset, see FIXME in jsdoc
    .addCase(resetAll, (state) => state));
//# sourceMappingURL=syncStateReducer.js.map